import { render, staticRenderFns } from "./IconBall.vue?vue&type=template&id=2b0c2e2c&scoped=true&"
import script from "./IconBall.vue?vue&type=script&lang=js&"
export * from "./IconBall.vue?vue&type=script&lang=js&"
import style0 from "./IconBall.vue?vue&type=style&index=0&id=2b0c2e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c2e2c",
  null
  
)

export default component.exports